import { BaseWebComponentDataProviderFactory } from '../../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../../webcomponents.constants';
import { GzSearchablePolicyPanelGzDataProvider } from '../dataProvider/GzSearchablePolicyPanelGzDataProvider';

export class GzSearchablePolicyPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, GzSearchablePolicyPanelGzDataProvider);
  }
}
